import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import TextField from '../../components/elements/form/TextField'
import FormButton from '../../components/elements/form/FormButton'
import { useDispatch } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../store/types'
import axios from 'axios'
import InlinePreloader from '../../components/elements/InlinePreloader'
import Countdown from '../../components/elements/Countdown'

const PasswordReset = () => {
  const dispatch = useDispatch()
  const [validationErrors, setValidationErrors] = useState({})  
  const [email, setEmail] = useState();

  const validateForm = () => {
    let errors = {}
    if(!email || email === '') {
        errors.email = true
    }
    setValidationErrors(errors)

    return errors
  }
  const [processing, setProcessing] = useState();
  const [requestSent, setRequestSent] = useState(false);
  const sendRequest = async () => {
    const headers = {
      'Content-Type': 'application/json'
    }
  
    if (Object.values(validateForm()).includes(true)) {

        dispatch({
            type: ERROR,
            error: {response: {data: {
                message: 'Please check the highlighted fields'
            }}}
        })
        return
    }

    setProcessing(true)

    const requestPayload = { 
        email,
        frontendUrl: window.location.origin
    }
    try {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/password-reset/request`, requestPayload, { headers })            

        dispatch({
          type: SET_SUCCESS,
          payload: 'Reset request sent, Please check your email.'
        })

        setRequestSent(true)
        setProcessing(false)
    } catch (error) {
        console.log(error)
        dispatch({
            type: ERROR,
            error
        })
        setProcessing(false)
    }
  }

  const [counted, setCounted] = useState(false);

  return (
    <div className="relative flex flex-row items-center justify-center w-full bg-vcm-light-purple bg-opacity-5 min-h-screen h-inherit">    
      <div className="w-11/12 lg:w-6/12 xl:w-4/12 p-4 lg:p-8 2xl:p-12 rounded-[8px] bg-white">
          <h1 className="text-xl font-thin text-primary mb-5 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>

          <h3 className="text-md">Lost your password?</h3>
          <p className="text-sm mt-[10px]">Please provide your registered email address and we'll send you an email with a link to create a new password</p>

          <div className='w-full mt-2'>
              <p className='text-gray-600 text-sm'>Don't have an account yet? <Link className='text-blue-500 font-[500]' to='signup'>Set up your account here</Link></p>
          </div>

          <div className='mt-4'>
              <TextField
                  inputLabel="Your email address" 
                  fieldId="email" 
                  inputType="text" 
                  preloadValue={''}
                  hasError={validationErrors && validationErrors.email} 
                  returnFieldValue={(value)=>{setEmail(value)}}
              />
          </div>

          <p className="my-3 text-sm text-opacity-70 block">Already done this? <Link to="/" className="text-blue-600">Return to log in</Link></p>
          
          {!requestSent && <div className='mt-8'>
              <FormButton buttonLabel="Request Password Reset" buttonAction={()=>{sendRequest()}} processing={processing} />
          </div>}

          {requestSent && <span>
            <div className='w-full text-left pt-[20px] border-t mt-10px'>
                <h1 className="font-thin text-xs text-primary mb-2 text-opacity-80 tracking-[0.2em] uppercase">Email sent</h1>
                <p className='text-sm'>Please check your inbox ({email || ''}) for an email from us. Click the link in the email to create your new password</p>

                <div className=''>
                    {counted 
                        ? 
                            <button 
                                className='bg-vcm-purple p-3 rounded-md mt-3 font-medium w-8/12 text-white transition duration-200 hover:bg-opacity-20 text-sm flex items-center justify-center' 
                                onClick={()=>{sendRequest()}}
                            >
                                {processing ? <InlinePreloader />  : 'Resend request'}
                            </button>
                        :
                        <>
                            <p className='py-2 mt-2 text-sm'>Didn&apos;t get the link? please wait <Countdown seconds={60} className='inline text-red-800 font-medium' countdownComplete={()=>{setCounted(true)}} /> seconds
                            </p>
                        </>
                    }
                </div>
            </div>
        </span>}

      </div>    
    </div>
  )
}

export default PasswordReset